import { render, staticRenderFns } from "./RoleDetails.vue?vue&type=template&id=32ca6840&"
import script from "./RoleDetails.vue?vue&type=script&lang=js&"
export * from "./RoleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports